module.exports = __webpack_public_path__ + "static/CookiesChef_part2_28_25-4a31e4ca662f832d43aeb656c0098dba.mp3";